const config = {
  baseUrl: "https://static.youka.club/binaries",
};

export default config;
